import type { JSX, PropsWithChildren } from 'react';

import styles from './FormGroup.module.css';

export default function FormGroup({
  children,
}: PropsWithChildren): JSX.Element {
  return <div className={styles.FormGroup}>{children}</div>;
}
